import { useState } from 'react';
import { PaginationQuery } from '../interfaces/paginationQuery.interface';
import { OrganizationModel } from '../models';
import { AxiosPublic } from '../utils/axios';

export const useGetAdminOrganization = () => {
  const [isFetching, setFetching] = useState(false);
  const [adminOrgItems, setAdminOrgItems] = useState<any>([]);
  return {
    isFetching,
    adminOrgItems,
    onLoad: async (queryParams?: PaginationQuery) => {
      setFetching(true);
      try {
        const { data } = await AxiosPublic.get('/organizations', {
          params: { ...queryParams, includeUserAdminCount: true, orderBy: 'position', order: 'ASC' },
        });
        setAdminOrgItems(data);
        setFetching(false);
      } catch (e) {
        setFetching(false);
      }
    },
  };
};
